// extracted by mini-css-extract-plugin
export var locationCard = "_gj-0";